import React, { useContext } from "react";
import * as Styled from "./style";
import {
  Grid,
  Typography,
  Divider
} from "@mui/material";
import { ThemeContext } from "../../context/ThemeContext";
import { screenSizes } from "../../constants/Constants";
import useCustomMediaQuery from "../../utils/useCustomMediaQuery";

export default function KpiMetricsForThree({
  KpiMetricsData,
  isHomePage = false,
  isGSNBA = false,
}) {
  const { mode } = useContext(ThemeContext);
  const isMobile = useCustomMediaQuery(screenSizes.mobile);
  const ipadMini = useCustomMediaQuery(screenSizes.ipadMini);
  const ipadPro = useCustomMediaQuery(screenSizes.ipadPro);
  const ipadAir = useCustomMediaQuery(screenSizes.ipadAir);

  const isNotDesktop = isMobile || ipadMini || ipadPro || ipadAir;

  function calculateMdProp(index) {
    if (isHomePage) {
      if (index === 1) {
        return 4.8;
      } else {
        return 3.5;
      }
    } else if (isGSNBA) {
      if (index == 0) {
        return 12;
      } else {
        return 5;
      }
    } else {
      return 3.9;
    }
  }

  function calculateSmProp(index) {
    if (isHomePage) {
      if (index === 1) {
        return 5.1;
      } else if (index === 0) {
        return 3.1;
      } else {
        return 3.6;
      }
    } else if (isGSNBA) {
      if (index == 0) {
        return 12;
      } else {
        return 5;
      }
    } else {
      return 3.8;
    }
  }

  function calculateXsProp(index) {
    if (isGSNBA) {
      if (index == 0) {
        return 8;
      } else {
        return 6;
      }
    } else {
      return 5.95;
    }
  }

  const metricsItems = KpiMetricsData?.map((metricItem, index) => {
    return (
      <React.Fragment key={metricItem?.text}>
        <Grid item>
          <Grid item key={metricItem?.text} height="100%">
            {/* Normal scenario, without any component check and for desktop */}
            {!isHomePage &&
              !isGSNBA &&
              !isNotDesktop &&
              ((index === 0 || index === 3) ? null : (
                <Divider
                  orientation="vertical"
                  flexItem
                  className="metricsDivider"
                  variant="middle"
                />
              ))}

            {/* Normal scenario, without any component check and for mobiles/tablets */}
            {!isHomePage &&
              !isGSNBA &&
              isNotDesktop &&
              (index === 0 || (isMobile && index === 2) ? null : (
                <Divider
                  orientation="vertical"
                  flexItem
                  className="metricsDivider"
                  variant="middle"
                />
              ))}

            {isHomePage && !isMobile && (index === 1 || index === 2) && (
              <Divider
                orientation="vertical"
                flexItem
                className="metricsDivider"
                variant="middle"
              />
            )}

            {isHomePage && isMobile && index === 1 && (
              <Divider
                orientation="vertical"
                flexItem
                className="metricsDivider"
                variant="middle"
              />
            )}

            {/* GSNBA is true, and device is desktop */}
            {isGSNBA &&
              !isMobile &&
              !isNotDesktop &&
              (index === 1 || index === 2) && (
                <Divider
                  orientation="vertical"
                  flexItem
                  className="longMetricsDivider"
                  variant="middle"
                />
              )}

            {/* GSNBA is true, and device is tablet */}
            {isGSNBA && !isMobile && isNotDesktop && index === 2 && (
              <Divider
                orientation="vertical"
                flexItem
                className="longMetricsDivider"
                variant="middle"
              />
            )}
          </Grid>
        </Grid>
        <Grid
          item
          container
          key={metricItem?.text}
          xs={calculateXsProp(index)}
          lg={3.9}
          md={calculateMdProp(index)}
          sm={calculateSmProp(index)}
          className="metricsItem"
        >
          <Grid item xs={12} className="metricsData">
            {metricItem?.data}
          </Grid>
          <Grid item xs={12}>
            <Typography className="metricsText">{metricItem?.text}</Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  });

  return (
    <Styled.KpiMetricsForThreeContainer
      data-testid="kpi-metrics-for-three-container"
      mode={mode}
    >
      <Grid container>{metricsItems}</Grid>
    </Styled.KpiMetricsForThreeContainer>
  );
}
